import {mapState} from "vuex";

export default {
    props: ['type_code', 'event_code'],
    data() {
        return {
            singleList: ['MS', 'WS', 'S'],
            doubleList: ['MD', 'WD', 'D', 'XD'],


            typeCode: this.type_code,
            eventCode: this.event_code,

            productList: [],
            userSearchIndex: -1,

            loadingCheck: false,

            playerList: []
        }
    },
    watch: {
        type_code: function (newVal) {
            this.typeCode = newVal
        },
        event_code: function (newVal) {
            this.eventCode = newVal
        },
        playerList: function (newVal) {
            this.$emit('input', newVal)
        }
    },
    computed: {
        ...mapState('me', ['me']),
        ...mapState('tournaments', ['tournament']),
    },
    mounted(){
        this.productList = this.tournament.productList
    },

    created() {

    },


}
